import classNames from 'classnames';
import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

// Configuration for button types and variants
const buttonProperties = {
	'SOLID': {
		'NEUTRAL': {
			className: 'DS__button-solid DS__button-solid--neutral'
		},
		'DESTRUCTIVE': {
			className: 'DS__button-solid DS__button-solid--destructive'
		},
		'STANDARD': {
			className: 'DS__button-solid DS__button-solid--standard'
		}
	},
	'GHOST': {
		'DESTRUCTIVE': {
			className: 'DS__button-ghost DS__button-ghost--destructive'
		},
		'STANDARD': {
			className: 'DS__button-ghost DS__button-ghost--standard'
		}
	},
	'LINK': {
		'STANDARD': {
			className: 'DS__button-link DS__button-link--standard'
		}
	},
	'SOLID_ICON': {
		'NEUTRAL': {
			className: 'DS__button_icon DS__button-solid_icon DS__button-solid_icon--neutral'
		},
		'STANDARD': {
			className: 'DS__button_icon DS__button-solid_icon DS__button-solid_icon--standard'
		},
		'DESTRUCTIVE': {
			className: 'DS__button_icon DS__button-solid_icon DS__button-solid_icon--destructive'
		}
	},
	'GHOST_ICON': {
		'NEUTRAL': {
			className: 'DS__button_icon DS__button-ghost_icon DS__button-ghost_icon--neutral'
		},
		'STANDARD': {
			className: 'DS__button_icon DS__button-ghost_icon DS__button-ghost_icon--standard'
		}
	},
	'UTILITY': {
		'UTILITY': {
			className: 'DS__button-utility'
		}
	},
	'CHIP': {
		'CHIP': {
			className: 'DS__button-chip'
		}
	}
	// Add other button types and variants here...
};

const Button = forwardRef((props, ref) => {
	// Get the appropriate class for the button
	const { dataTestId = 'button', type, variant, text, prefixIcon, suffixIcon, onClick, disabled, tooltipText, size, ...buttonProps } = props;
	const buttonConfig = buttonProperties[type]?.[variant];

	if (!buttonConfig) {
		console.error(`Variant ${variant} is not supported for button type ${type}.`);
		return `Variant ${variant} is not supported for type ${type}`;
	}

	const { className } = buttonConfig;

	const buttonClass = classNames(className, {
		'DS__button--small': size === 'small',
		'DS__button--default': size === 'default',
		'DS__button_icon--small': size === 'small',
		'DS__button_icon--lg': size === 'large',
		'DS__button_icon--xl': size === 'extraLarge',
		'DS__button-link': type === 'LINK',
		[`${className}--disabled`]: disabled
	});

	const handleButtonClick = (event) => {
		event.stopPropagation();
		if (onClick) {
			onClick(event);
		}
	};

	return (
		<BaseButton
			ref={ref} // Pass the ref down to BaseButton
			dataTestId={dataTestId}
			text={text}
			prefixIcon={prefixIcon}
			suffixIcon={suffixIcon}
			onClick={handleButtonClick}
			btnClassName={buttonClass}
			disabled={disabled}
			tooltipText={tooltipText}
			btnType={type}
			{...buttonProps}
		/>
	);
});

Button.displayName = 'Button';

export default Button;
